import React, { useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";

const InstallPwaPopup = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // التحقق إذا التطبيق مثبت بالفعل
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
    if (isStandalone) return;

    // التقاط الحدث عند استعداد الموقع للتثبيت
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPopup(true);
    };

    // التقاط حدث التثبيت
    const handleAppInstalled = () => {
      setShowPopup(false);
      setDeferredPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    // تنظيف الأحداث عند إلغاء المكون
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {
      console.log("User accepted installation");
    } else {
      console.log("User dismissed installation");
    }

    setShowPopup(false);
    setDeferredPrompt(null);
  };

  const handleClose = () => setShowPopup(false);

  if (!showPopup) return null;

  return (
    <div
      className="position-fixed bottom-0 end-0 p-3"
      style={{ zIndex: 1050 }}
    >
      <Card className="shadow-lg border-0" style={{ width: "20rem" }}>
        <Card.Body>
          <Card.Title>📱 Install CampusPulse</Card.Title>
          <Card.Text>
            Get quick access to CampusPulse by adding it to your home screen.
          </Card.Text>
          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" size="sm" onClick={handleClose}>
              Later
            </Button>
            <Button variant="primary" size="sm" onClick={handleInstall}>
              Install
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default InstallPwaPopup;
